( function ( _s ) {
	/**
	 * Check if the modal library is already loaded.
	 *
	 * @param libraryLoadedStatment boolean
	 * @param libArr                array
	 * @param callback              function
	 */
	const loadMicroModalLibrary = ( libraryLoadedStatment, libArr, callback ) => {
		if ( libraryLoadedStatment ) {
			callback();
		} else {
			window.fetchInject( libArr ).then( () => {
				callback();
			} );
		}
	};

	const modifyPosOfPaddlesAndDots = ( _slider, isMobile ) => {
		const _slides = _slider.find( '.splide__slide' );
		const _arrowsContainer = _slider.find( '.splide-arrows-container' );
		const _dots = _slider.find( '.splide__pagination' );

		if ( isMobile ) {
			//get all visible slides
			const _visibles = _s(
				_slides.el.filter( i => {
					return i.classList.contains( 'is-visible' );
				} )
			);
			let height = '';

			//get height of tallest content col
			_visibles.find( '.content-col' ).each( eli => {
				let currHeight = eli.offsetHeight;
				const style = getComputedStyle( eli );

				currHeight += parseInt( style.marginTop ) + parseInt( style.marginBottom );
				height = currHeight;
			} );

			_arrowsContainer.css( 'top', `${ height }px` );
			_dots.css( 'bottom', 'unset' ).css( 'top', `${ height }px` );
		} else {
			//reset
			_arrowsContainer.css( 'top', '' );
			_dots.css( 'top', '' ).css( 'bottom', '' );
		}
	};

	_s.fn.textPlusMediaSliderModule = function () {
		return this.each( el => {
			const _self = _s( el );
			const _playBtns = _self.find( 'button.play-btn' );

			//if there are play buttons, there are videos
			if ( _playBtns.el.length ) {
				//enable the buttons
				_playBtns.each( b => b.removeAttribute( 'disabled' ) );

				loadMicroModalLibrary(
					typeof window.MicroModal === 'object',
					[ 'https://unpkg.com/micromodal/dist/micromodal.min.js' ],
					() => {
						//initialize micromodal library
						window.MicroModal.init( {
							disableScroll: true,
							onShow: modal => _s( window ).trigger( 'micromodal-show', { modal } ),
							onClose: modal => _s( window ).trigger( 'micromodal-close', { modal } ),
						} );

						//event for click
						_playBtns.on( 'click', e => {
							//get config
							const btnConfig = JSON.parse(
								_s( e.currentTarget ).attr( 'video-config' ) || '{}'
							);

							//add html, show modal
							_s( `#video-modal` )
								.find( '.modal__content' )
								.html( `<div class="video-embed">` + btnConfig.html + `</div>` );
						} );

						//when the module's modal is closed, empty the content
						_s( window ).on( 'micromodal-close', e => {
							const _modal = _s( e.detail.modal );
							_modal.find( '.modal__content' ).html( '' );
						} );
					}
				);
			}

			//on window resize
			_s( window ).on(
				'resize',
				window.debounce( () => {
					modifyPosOfPaddlesAndDots(
						_self,
						[ 'xs', 'sm', 'md' ].includes( window.currentBreakpoint() )
					);
				}, 200 )
			);

			/* adds a nice effect on the paddles while changing the slides so that there's no visual jump */
			_self.on( 'fr-splide-move', e => {
				if ( [ 'xs', 'sm', 'md' ].includes( window.currentBreakpoint() ) ) {
					_self.addClass( 'hide-paddles-dots' );
				}
			} );

			_self.on( 'fr-splide-moved', e => {
				//when the splide has moved then we need to calculate the position
				modifyPosOfPaddlesAndDots(
					_self,
					[ 'xs', 'sm', 'md' ].includes( window.currentBreakpoint() )
				);

				if ( [ 'xs', 'sm', 'md' ].includes( window.currentBreakpoint() ) ) {
					//shows dots and paddles
					_self.removeClass( 'hide-paddles-dots' );
				}
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.text-plus-media-slider-module-container' ).textPlusMediaSliderModule();
	} );
} )( window._s );
